module.exports = __webpack_public_path__ + "img/co-branding-logo-ben-jerrys.d82c4b6a.png";